import { Provider, useDispatch, useSelector } from "react-redux";
import { PersistGate } from "redux-persist/lib/integration/react";
import store, { persistor } from "..";
import useAxios from "../../axios/axiosInterceptor";
import { setUpdatedBanCriteria } from "../common/commonSlice";
import { useEffect } from "react";
import { ThemeProvider } from "../../context/ThemeContext";

export function CustomProvider({ children }) {
  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <ThemeProvider>
          <ApisProvider>{children}</ApisProvider>
        </ThemeProvider>
      </PersistGate>
    </Provider>
  );
}

export default function ApisProvider({ children }) {
  const { accessToken } = useSelector((state) => state.authReducer);

  const dispatch = useDispatch();
  const { Get } = useAxios();

  useEffect(() => {
    if (accessToken) {
      // getUserData();
    }
    getCommonData();
  }, []);

  // const getUserData = async () => {
  //   const { response } = await Get({ route: "users/me" });
  //   if (response) {
  //     dispatch(updateUserData(response?.data));
  //   }
  // };

  const getCommonData = async () => {
    // const [{ response: appConfigResponse }] = await Promise.all([
    //   Get({ route: "admin/app-config/all/flag-and-ban" }),
    // ]);
    // if (appConfigResponse) {
    //   dispatch(
    //     setUpdatedBanCriteria({
    //       flag: appConfigResponse?.data?.flag || 1,
    //       ban: appConfigResponse?.data?.ban || 1,
    //       duration: appConfigResponse?.data?.duration || 1,
    //     })
    //   );
    // }
  };

  return children;
}
